import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import { GuestBuyerTypeId } from "utils";
import { useAuth } from "context/UseContext";

const Dashboard = lazy(() => import('views/dashboard'));
const GuestDashboard = lazy(() => import('views/guest-dashboard'));
const Orders = lazy(() => import('views/order-management/orders'));
const OrderDetail = lazy(() => import('views/order-management/orders/Detail.js'));
const ActivateMembership = lazy(() => import('views/membership/ActivateMembership'));
const UpdateMembership = lazy(() => import('views/membership/UpdateMembership'));
const Profile = lazy(() => import('views/profile'));
const ExternalStore = lazy(() => import('views/external-store'));
const ListedProducts = lazy(() => import('views/listed-product'));
const Transactions = lazy(() => import('views/transactions'));
const Refunds = lazy(() => import('views/refunds'));
const Chat = lazy(() => import('views/chat'));
const SupportList = lazy(() => import('views/support/List'));
const SupportNew = lazy(() => import('views/support/NewTicket'));
const SupportDetail = lazy(() => import('views/support/Detail'));

// *Home Route — guest buyers get their own dashboard, everyone else gets the buyer one
const Home = () => {
  const { user } = useAuth();
  return Number(user?.type) === GuestBuyerTypeId
    ? <Navigate to="/guest-dashboard" replace />
    : <Dashboard />;
}

// *Guest Dashboard Route — only guest buyers may open it
const GuestHome = () => {
  const { user } = useAuth();
  return Number(user?.type) === GuestBuyerTypeId
    ? <GuestDashboard />
    : <Navigate to="/" replace />;
}

const DashboardRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/guest-dashboard",
    component: <GuestHome />,
  },
  {
    path: "/order-management/orders",
    component: <Orders />,
  },
  {
    path: "/order-management/order-detail/:id",
    component: <OrderDetail />,
  },
  {
    path: "/membership-plan/activate-membership",
    component: <ActivateMembership />,
  },
  {
    path: "/membership-plan/update-membership",
    component: <UpdateMembership />,
  },
  {
    path: "/profile",
    component: <Profile />,
  },
  {
    path: "/external-store",
    component: <ExternalStore />,
  },
  {
    path: "/listed-products",
    component: <ListedProducts />,
  },
  {
    path: "/transactions",
    component: <Transactions />,
  },
  {
    path: "/refund-return",
    component: <Refunds />,
  },
  {
    path: "/chat",
    component: <Chat />,
  },
  {
    path: "/support",
    component: <SupportList />,
  },
  {
    path: "/support/new",
    component: <SupportNew />,
  },
  {
    path: "/support/:id",
    component: <SupportDetail />,
  },
]

export default DashboardRoutes
